import { render, staticRenderFns } from "./changeMobileDc.vue?vue&type=template&id=2a9b46aa&scoped=true"
import script from "./changeMobileDc.vue?vue&type=script&lang=js"
export * from "./changeMobileDc.vue?vue&type=script&lang=js"
import style0 from "./changeMobileDc.vue?vue&type=style&index=0&id=2a9b46aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9b46aa",
  null
  
)

export default component.exports